module.exports={
    btn:{
        tips_reelect_btn:"Yeni görüntü",
        cancel_btn:"İptal etmek",
        tips_continue_dispose:"Lüks Desteklenen Görseller",
        tips_return:"Yeni görüntü",
        tips_upgrade:"Güncelleme",
        tips_yes:"TAMAM",
        delete:"Silmek",
        download:"İndirmek",
        upload_image:"Fotoğraf yükleniyor",
        new_image:"Yeni görüntü",
        save_all:"Hepsini kaydet",
        cancel:"İptal",
        save:"Kaydetmek",
        view_comparison:"Karşılaştırmayı Görüntüle",
        hide_comparison:"Karşılaştırmayı Gizle",
        previous:"Öncesi",
        next:"Sonraki",
        continue_download:"Görüntüleri Filigranlarla Kaydet",
        present:"Bu Resme Uygula",
        all_wait:"Beklemedeki Görüntülere Uygula",
        all:"Tüm Görsellere Uygula",
        history:"Tarih",
        login:"Giriş yapmak",
    },
    tips:{
        please_upgrade:"Mevcut planınız, resimleri toplu olarak yüklemeyi veya yükseltmeyi desteklemiyor. Daha fazla avantajdan yararlanmak için lütfen yükseltin.",
        errorlistinfo:"XXX resimler seçildi. XXX resimler desteklenir, ancak XXX resimler desteklenmez. Aşağıdakiler desteklenmeyen resimlerdir:",
        max:"10 MB'lık maksimum resim boyutu sınırını aşın!",
        max_size:"4096 piksellik maksimum görüntü kenar uzunluğu sınırını aşın!",
        continue_dispose:"Lüks Desteklenen Görseller",
        please_multiple:"Lütfen büyütmeyi seçin.",
        max_multiple:"* Resminiz en fazla 4K olarak büyütülecektir (en uzun kenar 4096px'i geçmeyecektir).",
        title:"İsim",
        reasons:"Sebepler",
        upload_type:"Desteklenmiyor",
        used_up:"Filigran olmadan kaydedilen HD görüntülerin sayısı tükendi. Lütfen hesabınızı yükseltin. Veya HD görüntüleri filigranlarla kaydedebilirsiniz.",
        edit_multiple:"Yüklenen birden fazla resim var. Lütfen büyütme oranını değiştirmek istediğiniz resimleri seçin. Seçtikten sonra, bu görüntüler yeniden yeni büyütmeye yükseltilecektir.",
        download_confirm:"Bazı resimler hala işleniyor. Yükseltilmiş tüm görüntüleri kaydedeceğinizden emin misiniz? Aynı görüntüyü tekrar tekrar kaydettiğinizde, kaydedilen görüntü sayınız tekrar düşülmez.",
        waiting_save:"Bazı resimler hala işleniyor. Lütfen daha sonra kaydedin.",
        
    },
    header:{
        title:"Aiseesoft Görüntü Yükseltici Çevrimiçi",
        hd:" HD görüntü(ler)",
        watermarks:"filigran olmadan şu anda indirilebilir.",
        view_details:"Detayları göster",
        loading:"Yükleniyor…",
    },
    content:{
        failed:"Arızalı",
        completed:"Tamamlanmış",
        processing:"İşleme",
        img_processing:"İşleme…",
        img_failed:"İşlenemedi",
        uploading:"yükleniyor",
        img_uploading:"yükleniyor…",
        wait_upoading:"Yükleme bekleniyor…",
        waiting:"Beklemek",
        img_waiting:"Beklemek…",
        empty:"Boş",
        magnification:"Büyütme:",
        drop:"Veya yükseltmek ve geliştirmek için resim dosyanızı buraya bırakın!",
        original:"Orijinal:",
        output:"Çıktı:",
        img_rendering1:"Resminiz yükseltildi.",
        img_rendering2:"Önizleme için yüksek kaliteli görüntüyü oluşturmaya çalışıyoruz, lütfen bekleyin...",
        no_watermark:"Kaydettikten sonra görüntüde filigran kalmaz.",
    },
    banner_msg:"Image Upscaler için bir Plan Seçin",
    monthly:"AYLIK",
    lifetime:"ÖMÜR",
    choose_plan:"Görüntü sayısına göre planınızı seçin",
    return_home:"Tebrikler! Başarıyla yükselttiniz. Lütfen ana sayfaya dönün ve bu ürünü kullanın.",
    congratulations:"Tebrikler! Başarıyla yükselttiniz. Avantajlar, yükseltme yaparken bıraktığınız e-posta adresine bağlandı. Lütfen kayıtlı veya e-posta adresine bağlı hesabı kullanın.",
    login_benefits:"avantajları kullanmak için giriş yapın",
    no_registered:". Kayıt olmadıysanız veya e-posta adresiyle bir hesap bağlamadıysanız, lütfen",
    register_account:"bir hesap kaydetmek için e-posta adresini kullanın",
    other_accounts:" veya avantajlardan yararlanmak için bu e-posta adresine başka hesaplar bağlayabilirsiniz.",
    btn_close:"Kapalı",
    free:"Özgür",
    btn_get_started:"Başlamak",
    // access_to:"Erişim",
    upscale_images:"Lüks görüntüler",
    up_to:"kadar",
    per_image:" resim başına",
    resolution_of:"Çözünürlüğe kadar",
    default_level:"Görüntüleri varsayılan düzeyde lüks hale getirin",
    image_downloads:"Filigran olmadan 2 HD görüntü indirme",
    unlimited_image:"Filigran ile sınırsız resim indirme",
    SHA256_encryption:"SHA256 şifreleme tekniği",
    mon:"Aylık",
    images:"Görüntüler",
    high_resolution:" yüksek çözünürlüklü kalite ile",
    tax_incl:"Vergi dahil.",
    image:"resim",
    secure_checkout:"Güvenli Ödeme",
    everything:"Her şey Bedava ve",
    upscaling_levels:"Tüm yükseltme seviyeleri seçilebilir",
    unlimited_image_without:"Filigran olmadan sınırsız resim indirme",
    viewable_editing:"Görüntülenebilir düzenleme geçmişi şu süre için geçerlidir:",
    days:" günler",
    high_level:"Yüksek seviye",
    priority_processing:" öncelikli işleme",
    left:"Ömür",
    resolution:" çözünürlük",


    "history_will":"sonra sona erecek",
    "history.days":"gün(ler)",
    "history.hours":"saat",
    "expired":"Günü geçmiş",
    "access_to":"Ücretsiz deneme sürümüyle yalnızca şunları yapabilirsiniz:",
    "pricing.upload_images":"resim yükle",
    "pricing.under":"altında",
    "pricing.images":"Görüntüler",
    "pricing.without_watermark":"filigran olmadan",
    "pricing.process_images":"Şuna kadar görüntüleri işleyin:",
    "pricing.pixels":"piksel",
    "pricing.enjoy_limited":"Sınırlı lüks sınıfların keyfini çıkarın",
    "pricing.download":"İndirmek",
    "pricing.HD_images":"Filigransız HD görüntüler",
    "pricing.and_you":"Ve acı çekebilirsiniz",
    "pricing.slow_upscaling":"yavaş yükseltme",
    "pricing.lower_priority":"daha düşük öncelik",
    "pricing.without":"filigran olmadan",
    "pricing.tax":"Vergi satış fiyatına dahildir ve ülkenize ve bölgenize göre otomatik olarak hesaplanacaktır. Alışveriş sepetinde detaylı vergi tutarını görebilirsiniz. Son ödeme tutarınız görüntülenen fiyat ile aynı olacaktır.",
    "pricing.you_can":"Abonelik ile yapabilirsiniz",
    "pricing.up_to":"kadar resim yükleyin",
    "pricing.upscale_images":"ile lüks görüntüler",
    "pricing.no_watermark":"filigran yok",
    "pricing.enhance":"Genişletmek",
    "pricing.or_more":"resimler veya daha fazlası",
    "pricing.in_batch":"Parti halinde",
    "pricing.enlarge_images":"Resimleri büyüt",
    "pricing.and":"Ve",
    "pricing.times_with":"limitsiz zamanlar",
    "pricing.enjoy":"Eğlence",
    "pricing.of_history":"geçmiş depolama süresi",
    "pricing.experience":"Deneyim",
    "pricing.fast_upscaling":"hızlı yükseltme",
    "pricing.higher_priority":"daha yüksek öncelik",
    "pricing.early_access":"Yeni özelliklere erken erişim",
    "pricing.cancel_anytime":"istediğiniz zaman iptal edin",
    "pricing.lifetime_license":"Ömür boyu lisans ile şunları yapabilirsiniz:",
    "pricing.and_there":"Ve olacak",
    "pricing.no_expiration":"Son kullanma tarihi yok",
    "pricing.unless":"tüm lüksleri bitirmedikçe",

    "buynow.pop.credit":"kredi",
    "buynow.pop.credits":"kredi",

    "isUnderequityTip_msg1":"Toplu işleme için {%} görsel seçtiniz ve kalan yeterli avantaj yok, Hala {%} krediye ihtiyacınız var (şu anda {%} kredi kaldı), İşlemeniz gerekiyorsa lütfen devam etmek için avantajları satın alın görüntülerin işlenmesi.",
    "isUnderequityTip_msg2":"Toplu işleme için {%} görsel seçtiniz ve kalan yeterli avantaj yok, Hala {%} krediye ihtiyacınız var (şu anda {%} avantaj görseli kaldı), İşlemeniz gerekiyorsa lütfen avantajları satın alın Görüntüleri işlemeye devam etmek için",
    "isUnderequityTip_msg3":"Toplu işleme için {%} görsel seçtiniz ve kalan yeterli avantaj yok, Hala {%} krediye ihtiyacınız var (şu anda {%} kredi var, {%} avantaj görseli kaldı), İhtiyacınız varsa işlem, lütfen görüntüleri işlemeye devam etmek için avantajları satın alın.",
    "btn_buy_now":"Şimdi satın al",
    "isEquityDepletionTip_msg":"Mevcut avantajlarınız tükendi. Lütfen toplu işleme yönelik avantajları satın alın.",

    "pricing.h1":"Aiseesoft AI Photo Editor - Planlar ve Fiyatlandırma",
    "pricing.banner_content":"AI Photo Editor kredilerini edinin; görsel arka planlarını kaldırın, görselleri büyütün ve çevrimiçi veya masaüstünden görsellerden nesneleri kaldırın.",
    "pricing.best_seller":"En Çok Satan",
    "pricing.monthly":"Aylık Abonelik",
    "pricing.credits":"kredi",
    "pricing.lifetime":"Ömür Boyu",
    "pricing.note":"Not",
    "pricing.buy_now":"Şimdi satın al",
    "pricing.note_content":"Satın alınan krediler, alışveriş sepetine girdiğiniz e-posta adresine bağlıdır. Bu kredileri kullanmak için lütfen aynı e-posta adresini kullanarak kaydolun veya giriş yapın.",

    "header.buy_more":"Daha fazla satın al",
    "header.available_credits":"Mevcut Krediler",
    "header.credits":"kredi"
}